import axios from 'axios';
import config from '../config';

const addProperty = async data => {
  const res = await axios.post(`${config.API_URL}/api/properties/`, data);
  return res;
};

export default addProperty;
